
(function(){
  if (window.__almKlarnaFiche) return; window.__almKlarnaFiche = 1;

  function money(cents, currency){
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch(e){
      return (Math.round(cents) / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  /* 09/09 correction : ce theme n'a PAS de "mz-price-block". Le prix de la
     fiche vit dans la carte de pack active (.almpk__c.is-on .almpk__pr) et le
     bouton d'achat dans une ligne [class*="mz-atc-row"]. On lit le prix la, et
     on POSE la mention juste au dessus du bouton d'achat. */
  function priceBlock(){
    /* 25/09 : le prix affiché de la fiche (suit la variante) */
    return document.querySelector('[id^="mzEcoPrice-"]')
        || document.querySelector('.almpk__c.is-on .almpk__pr')
        || document.querySelector('.almpk__c .almpk__pr')
        || document.querySelector('[class*="mz-price-block"]');
  }
  /* 09/09, demande de Lancelot : la mention se pose SOUS le bouton
     "Achat rapide" (le bouton de paiement accelere, class mz-gpay-btn).
     Replis si ce bouton n'existe pas sur la fiche. */
  function ancre(){
    /* 25/09 01h15 (Lancelot) : la mention passe SOUS LE PRIX (dans le bloc prix, en dernier). */
    var pe = document.querySelector('[class*="mz-x-price-economy-"]');
    if (pe) return [pe, 'dedans'];
    var gpay = document.querySelector('[class*="mz-gpay-btn"]');
    if (gpay) return [gpay.closest('[class*="mz-gpay-row"]') || gpay, 'apres'];
    var row = document.querySelector('[class*="mz-atc-row"]');
    if (row) return [row, 'apres'];
    var btn = document.querySelector('[class*="mz-atc-btn"]:not([class*="sticky"])');
    return btn ? [btn, 'apres'] : null;
  }
  function placer(){
    var host = document.getElementById('almKlarnaFiche');
    if (!host) return false;
    if (host.dataset.almkPlaced === '1') return true;
    var a = ancre();
    if (!a || !a[0] || !a[0].parentNode) return false;
    var cible = a[0];
    if (a[1] === 'dedans') cible.appendChild(host);
    else if (a[1] === 'avant') cible.parentNode.insertBefore(host, cible);
    else cible.parentNode.insertBefore(host, cible.nextSibling);
    host.dataset.almkPlaced = '1';
    return true;
  }
  var essaisPlace = 0;
  (function poser(){ if (!placer() && ++essaisPlace < 30) setTimeout(poser, 400); })();
  function priceTextNode(block){
    if (!block) return null;
    var spans = block.querySelectorAll('[class*="mz-price-"]');
    for (var i = 0; i < spans.length; i++){
      var c = spans[i].className || '';
      if (/mz-price-/.test(c) && !/compare|badge|block/.test(c)) return spans[i];
    }
    return block;
  }
  function parseCents(node){
    if (!node) return null;
    var t = (node.textContent || '').replace(/[^\d,.\s]/g, '').trim();
    if (!t) return null;
    t = t.replace(/\s/g, '');
    /* format FR "1 234,56" ou "90,00" : la virgule est le separateur decimal */
    if (t.indexOf(',') > -1) { t = t.replace(/\./g, '').replace(',', '.'); }
    var n = parseFloat(t);
    if (!isFinite(n)) return null;
    return Math.round(n * 100);
  }

  function render(cents){
    var host = document.getElementById('almKlarnaFiche');
    if (!host) return;
    var min = parseInt(host.getAttribute('data-almk-min'), 10);
    var max = parseInt(host.getAttribute('data-almk-max'), 10);
    if (cents == null || !isFinite(cents) || cents < min || cents > max) { host.hidden = true; return; }
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var amt = document.getElementById('almkAmount');
    /* le 1er versement absorbe l'arrondi : la somme des trois fait le prix. */
    /* 25/09 (Lancelot) : paiement en 4 fois (PayPal ou Klarna) */
    var base = Math.floor(cents / 3);
    var premier = cents - base * 2;
    if (amt) amt.textContent = money(Math.round(cents / 4), cur);
    var ech = host.querySelectorAll('[data-almk-ech]');
    if (ech.length === 3){
      ech[0].textContent = money(premier, cur);
      ech[1].textContent = money(base, cur);
      ech[2].textContent = money(base, cur);
    }
    host.hidden = false;
  }

  var lastCents = null;
  function checkPrice(){
    var c = parseCents(priceTextNode(priceBlock()));
    if (c == null || c === lastCents) return;
    lastCents = c;
    render(c);
  }

  function armObserver(){
    var block = priceBlock();
    if (!block) return false;
    block = block.closest('.almpk__grid') || block;
    try {
      var mo = new MutationObserver(function(){ checkPrice(); });
      /* 10/09 : quand Lancelot choisit le pack 2 ou 3, le texte ne bouge pas,
         c'est la classe is-on qui change de carte. Sans attributes:true le
         montant restait bloque sur le prix d'une seule applique. */
      mo.observe(block, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    } catch(e){}
    /* filet : un clic sur une carte de pack relance le calcul juste apres */
    try {
      block.addEventListener('click', function(){
        setTimeout(checkPrice, 30);
        setTimeout(checkPrice, 200);
        setTimeout(checkPrice, 600);
      }, true);
    } catch(e){}
    checkPrice();
    return true;
  }
  var tries = 0;
  (function arm(){ if (!armObserver() && ++tries < 25) setTimeout(arm, 400); })();

  /* filet de secours : verifie le prix affiche independamment de l'observateur */
  var polls = 0;
  var poller = setInterval(function(){
    checkPrice();
    if (++polls >= 20) clearInterval(poller);
  }, 500);

  var toggle = document.getElementById('almkToggle');
  if (toggle) {
    toggle.addEventListener('click', function(){
      var host = document.getElementById('almKlarnaFiche');
      var open = host.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Schließen' : 'Mehr erfahren';
    });
  }
}());
